import { render, staticRenderFns } from "./ActionTag.vue?vue&type=template&id=584f62ca"
import script from "./ActionTag.vue?vue&type=script&lang=js"
export * from "./ActionTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports